import React from 'react';
import { Link, withRouter, Route } from 'react-router-dom';

const Heading = ({ location }) => {
  let admin = localStorage.getItem('type') === 'admin';
  let companyAdmin = localStorage.getItem('type') === 'company admin';

  return (
    <div id="head">
      <div id="title">Settings</div>
      <div id="subnav">
        {location.pathname.match(/settings\/users/) && admin
          ? <Link className="action" to="/settings/users/add">Add User</Link>
          : null}
        {location.pathname === '/settings/companies' && admin
          ? <Link className="action" to="/settings/companies/add">
              Add Company
            </Link>
          : null}

        <Route
          path="/settings/companies/:id/users"
          render={props => (
            <Link
              className="action"
              to={`/settings/companies/${props.match.params.id}/add-user`}
            >
              Add User
            </Link>
          )}
        />
        {companyAdmin || admin
          ? <Link
              className={
                location.pathname.match('/settings/companies') ? 'active' : ''
              }
              to="/settings/companies"
            >
              Companies
            </Link>
          : null}
        {admin
          ? <Link
              className={
                location.pathname.match('/settings/users') ? 'active' : ''
              }
              to="/settings/users"
            >
              Staff
            </Link>
          : null}
        <Link
          className={location.pathname === '/settings' ? 'active' : ''}
          to="/settings"
        >
          My Account
        </Link>
      </div>
    </div>
  );
};

export default withRouter(Heading);



// WEBPACK FOOTER //
// ./src/views/settings/heading.js